import React from 'react';
import { APPLICATION_TYPE, LAYOUT_TYPE } from '../../../../../App/AppSettings';
import Layout from '../../../../../Layout';
import history from '../../../../../Shared/History';
import '../../../../Content.css';
import { FormProcessing, LicenceDetailsView } from '../../../Components';
import * as Actions from '../../../Components/FormProcessing/Actions';
import { SpfLiquor1To4Amend, SpfLiquor1To4Apply, SpfLiquor1To4Renewal } from '../../../SpfLiquor1To4/V1/SpfLiquor1To4Components/ApplicationInfoSection';

const ApplicationInfoComponent = {
	[APPLICATION_TYPE.APPLY]: SpfLiquor1To4Apply,
	[APPLICATION_TYPE.RENEWAL]: SpfLiquor1To4Renewal,
	[APPLICATION_TYPE.AMEND]: SpfLiquor1To4Amend
}

const CustomActions = {
	'Request For Clarification': Actions.SubmitClarification,
	'Approve And Request For Additional Payment': Actions.SubmitAdditionalPayment
}

// THIS COMPONENT IS DEPRECITATED
class LiquorLicence1To4Processing extends React.Component {

	constructor(props) {
		super(props);
		this.state = { toggleCheckOut: true };
	}

	async componentDidMount() {
		const { setPageNotFound } = this.props;
		const { state } = history.location;
		const isPageNotFound = state === undefined || state.ID === undefined;

		await this.setState({ isPageNotFound });

		setPageNotFound(isPageNotFound);
	}

	toggleCheckInCheckOut = () => {
		this.setState((prevState) => {
			return {
				toggleCheckOut: !prevState.toggleCheckOut
			}
		})
	}

	render() {
		const { isPageNotFound } = this.state;
		if (isPageNotFound === undefined || isPageNotFound) return null;

		return (
			<Layout type={LAYOUT_TYPE.FORM} title="Review Application" footer={false} titleClassName="sticky-title"
				titleChildren={
					<FormProcessing
						isAction={true}
						customActions={CustomActions}
						toggleCheckInCheckOut={this.toggleCheckInCheckOut}
					/>
				}>
				<LicenceDetailsView
					toggleCheckInCheckOut={this.state.toggleCheckOut}
					applicationInfoComponent={ApplicationInfoComponent}
				/>
			</Layout>
		);
	}
}

export default LiquorLicence1To4Processing;